import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { it } from './locales/it';
import { en } from './locales/en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      it,
      en
    },
    lng: 'it', // Default language
    fallbackLng: 'it',
    interpolation: {
      escapeValue: false // React handles escaping
    }
  });

export default i18n;
